import { Button, makeStyles, Typography } from "@material-ui/core";
import { Download } from "@mui/icons-material";
import React from "react";
import AppConfig from "../../../AppConfig";
import ContactFormModal from "../../modals/ContactFormModal";
import HomepageDownloadModal from "../../modals/HomepageDownloadModal";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    position: "relative",
    width: "100%",
    margin: "0rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  imageAndTextContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    zIndex: 1,
  },
  illustrationSizer: {
    objectFit: "cover",
    width: "100%",
    height: "90vh",
    [theme.breakpoints.down("xs")]: {
      height: "70vh",
    },
  },
  overlayContainer: {
    position: "absolute",
    bottom: "3rem",
    width: "100%",
    display: "flex",
    zIndex: 999,
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0rem 8rem 0.5rem 8rem",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      padding: "0rem 2rem 0rem 2rem",
      bottom: "2rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 4rem 0rem 4rem",
    },
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "80%",
    zIndex: 999,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "70%",
    },
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: 600,
    lineHeight: "3.5rem",
    color: "#FFFFFF",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  subheading: {
    fontSize: "1.25rem",
    fontWeight: 400,
    lineHeight: "2rem",
    color: "#FFFFFF",
    width: "90%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
    },
  },
  btnRow: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "1rem",
    zIndex: 999,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      justifyContent: "flex-start",
      width: "100%",
      margin: "1rem 0rem 0rem 0rem",
      gap: "0.5rem",
    },
  },
  primaryButton: {
    padding: "0.5rem 1rem",
    background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    color: "#FFFFFF",
    fontSize: "1rem",
    fontWeight: "500",
    borderRadius: "0.75rem",
    textTransform: "none",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: "0.5rem 0.5rem",
    },
  },
  secondaryButton: {
    background: "#FFFFFF",
    color: "#0DB14B",
    border: "solid 1px #0DB14B",
    padding: "0.5rem 1rem",
    fontSize: "1rem",
    fontWeight: "500",
    textTransform: "none",
    width: " 100%",
    borderRadius: "0.75rem",
    [theme.breakpoints.down("xs")]: {
      width: "80%",
    },
  },
}));

const SectionImage = () => {
  const classes = useStyles();
  const [openDownload, setOpenDownload] = React.useState(false);
  const handleClose = () => {
    setOpenDownload(false);
  };
  const handleOpen = () => {
    setOpenDownload(true);
  };
  const [openContactForm, setOpenContactForm] = React.useState(false);
  const handleOpenContactForm = () => {
    setOpenContactForm(true);
  };
  const handleCloseContactForm = () => {
    setOpenContactForm(false);
  };
  return (
    <React.Fragment>
      <HomepageDownloadModal
        open={openDownload}
        onClose={handleClose}
        source="Download PDF"
        submitCallback={(data) => {
          setOpenDownload(false);
        }}
      />
      <ContactFormModal
        open={openContactForm}
        onClose={handleCloseContactForm}
        source="Heavie Eden Desktop"
      />
      <div className={classes.megaContainer}>
        <div className={classes.imageAndTextContainer}>
          <img
            src="/images/icons/heavie/aboutus/about_new.webp"
            alt={AppConfig.imageAltText}
            width={512}
            height={512}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
          />
          <div className={classes.overlayContainer}>
            <div className={classes.textContainer}>
              <Typography
                variant="h4"
                className={classes.heading}
              >
                About us
              </Typography>
              <Typography
                variant="body2"
                className={classes.subheading}
              >
                Sentient was born to create sustainable solutions to the most profound challenges of real estate. We
                develop conscious structures across all verticals - residential, commercial, and industrial - with deep
                respect for nature and a commitment to future generations. With three generations of experience behind
                us, we don’t just build, we design for evolution.
              </Typography>
            </div>
            <div className={classes.btnRow}>
              <Button
                variant="outlined"
                onClick={handleOpen}
                title="download brochure"
                rel="noopener"
                className={classes.primaryButton}
                endIcon={<Download />}
              >
                Download Brochure
              </Button>
              <Button
                variant="outlined"
                onClick={handleOpenContactForm}
                title="Get a callback"
                rel="noopener"
                className={classes.secondaryButton}
              >
                Get callback
              </Button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SectionImage;
